import { render, staticRenderFns } from "./ChatWelcomeRoom.vue?vue&type=template&id=ef7f6b30&scoped=true"
import script from "./ChatWelcomeRoom.vue?vue&type=script&lang=js"
export * from "./ChatWelcomeRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatWelcomeRoom.vue?vue&type=style&index=0&id=ef7f6b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7f6b30",
  null
  
)

export default component.exports